import React from 'react';
import { useLocation } from 'react-router';
import { parseURI, URI } from '@spotify-internal/uri';

import { getContextQueryParams } from 'components/ContentReporting/form-utils';
import { Platform } from 'components/ContentReporting/shared-constants';

export interface Context {
  contextUri?: URI | undefined;
  playbackTimestamp?: number | undefined;
}

export interface ContextualInfoProps {
  platform?: Platform | undefined;
  context: Context;
}

export const withContextualInfo = <P extends ContextualInfoProps>(Comp: React.ComponentType<P>) => {
  return (props: Omit<P, keyof ContextualInfoProps>) => {
    const location = useLocation();
    const { platform, context_uri, playback_timestamp } = getContextQueryParams(location);
    return (
      <Comp
        {...(props as P)}
        platform={Object.values(Platform).includes(platform as Platform) ? platform : undefined}
        context={{
          contextUri: parseURI(context_uri as string) || undefined,
          playbackTimestamp: parseInt(playback_timestamp as string, 10) || undefined,
        }}
      />
    );
  };
};
